"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TablePaginationActions = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _span, _span2, _span3, _span4;
function LastPageIconDefault() {
    return _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: '⇾|'
    }));
}
function FirstPageIconDefault() {
    return _span2 || (_span2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: '|⇽'
    }));
}
function NextPageIconDefault() {
    return _span3 || (_span3 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: '⇾'
    }));
}
function BackPageIconDefault() {
    return _span4 || (_span4 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: '⇽'
    }));
}
function defaultGetAriaLabel(type) {
    return "Go to ".concat(type, " page");
}
/**
 * @ignore - internal component.
 */ var TablePaginationActions = exports.TablePaginationActions = /*#__PURE__*/ React.forwardRef(function TablePaginationActions(props, forwardedRef) {
    var count = props.count, _props_getItemAriaLabel = props.getItemAriaLabel, getItemAriaLabel = _props_getItemAriaLabel === void 0 ? defaultGetAriaLabel : _props_getItemAriaLabel, onPageChange = props.onPageChange, page = props.page, rowsPerPage = props.rowsPerPage, _props_showFirstButton = props.showFirstButton, showFirstButton = _props_showFirstButton === void 0 ? false : _props_showFirstButton, _props_showLastButton = props.showLastButton, showLastButton = _props_showLastButton === void 0 ? false : _props_showLastButton, direction = props.direction, // @ts-ignore
    ownerStateProp = props.ownerState, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, other = _object_without_properties(props, [
        "count",
        "getItemAriaLabel",
        "onPageChange",
        "page",
        "rowsPerPage",
        "showFirstButton",
        "showLastButton",
        "direction",
        "ownerState",
        "slotProps",
        "slots"
    ]);
    var ownerState = props;
    var handleFirstPageButtonClick = function(event) {
        onPageChange(event, 0);
    };
    var handleBackButtonClick = function(event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function(event) {
        onPageChange(event, page + 1);
    };
    var handleLastPageButtonClick = function(event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    var _slots_root;
    var Root = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : 'div';
    var rootProps = (0, _utils.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState: ownerState
    });
    var _slots_firstButton;
    var FirstButton = (_slots_firstButton = slots.firstButton) !== null && _slots_firstButton !== void 0 ? _slots_firstButton : 'button';
    var firstButtonProps = (0, _utils.useSlotProps)({
        elementType: FirstButton,
        externalSlotProps: slotProps.firstButton,
        additionalProps: {
            onClick: handleFirstPageButtonClick,
            disabled: page === 0,
            'aria-label': getItemAriaLabel('first', page),
            title: getItemAriaLabel('first', page)
        },
        ownerState: ownerState
    });
    var _slots_lastButton;
    var LastButton = (_slots_lastButton = slots.lastButton) !== null && _slots_lastButton !== void 0 ? _slots_lastButton : 'button';
    var lastButtonProps = (0, _utils.useSlotProps)({
        elementType: LastButton,
        externalSlotProps: slotProps.lastButton,
        additionalProps: {
            onClick: handleLastPageButtonClick,
            disabled: page >= Math.ceil(count / rowsPerPage) - 1,
            'aria-label': getItemAriaLabel('last', page),
            title: getItemAriaLabel('last', page)
        },
        ownerState: ownerState
    });
    var _slots_nextButton;
    var NextButton = (_slots_nextButton = slots.nextButton) !== null && _slots_nextButton !== void 0 ? _slots_nextButton : 'button';
    var nextButtonProps = (0, _utils.useSlotProps)({
        elementType: NextButton,
        externalSlotProps: slotProps.nextButton,
        additionalProps: {
            onClick: handleNextButtonClick,
            disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
            'aria-label': getItemAriaLabel('next', page),
            title: getItemAriaLabel('next', page)
        },
        ownerState: ownerState
    });
    var _slots_backButton;
    var BackButton = (_slots_backButton = slots.backButton) !== null && _slots_backButton !== void 0 ? _slots_backButton : 'button';
    var backButtonProps = (0, _utils.useSlotProps)({
        elementType: BackButton,
        externalSlotProps: slotProps.backButton,
        additionalProps: {
            onClick: handleBackButtonClick,
            disabled: page === 0,
            'aria-label': getItemAriaLabel('previous', page),
            title: getItemAriaLabel('previous', page)
        },
        ownerState: ownerState
    });
    var _slots_lastPageIcon;
    var LastPageIcon = (_slots_lastPageIcon = slots.lastPageIcon) !== null && _slots_lastPageIcon !== void 0 ? _slots_lastPageIcon : LastPageIconDefault;
    var _slots_firstPageIcon;
    var FirstPageIcon = (_slots_firstPageIcon = slots.firstPageIcon) !== null && _slots_firstPageIcon !== void 0 ? _slots_firstPageIcon : FirstPageIconDefault;
    var _slots_nextPageIcon;
    var NextPageIcon = (_slots_nextPageIcon = slots.nextPageIcon) !== null && _slots_nextPageIcon !== void 0 ? _slots_nextPageIcon : NextPageIconDefault;
    var _slots_backPageIcon;
    var BackPageIcon = (_slots_backPageIcon = slots.backPageIcon) !== null && _slots_backPageIcon !== void 0 ? _slots_backPageIcon : BackPageIconDefault;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, _object_spread_props(_object_spread({}, rootProps), {
        children: [
            showFirstButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FirstButton, _object_spread_props(_object_spread({}, firstButtonProps), {
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LastPageIcon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(FirstPageIcon, {})
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackButton, _object_spread_props(_object_spread({}, backButtonProps), {
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextPageIcon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackPageIcon, {})
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextButton, _object_spread_props(_object_spread({}, nextButtonProps), {
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackPageIcon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextPageIcon, {})
            })),
            showLastButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LastButton, _object_spread_props(_object_spread({}, lastButtonProps), {
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(FirstPageIcon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LastPageIcon, {})
            }))
        ]
    }));
});
